import { Outlet } from "react-router-dom";
import { useTheme } from "./useTheme";


export default function Theme() {
  const currentTheme = useTheme();
  return (
    <div className={currentTheme} style={{
      display: "flex",
      flexDirection: "column",
      height: "100%",
      width: "100%",
    }}>
      <Outlet />
    </div>
  );
}
